(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initTopUSPBar(bar) {

    if (!bar) return;

    if (bar.dataset.initialized === 'true') {
      return;
    }

    bar.dataset.initialized = 'true';


    const inner =
      bar.querySelector(
        '.top-usp-bar__inner'
      );


    const items =
      bar.querySelectorAll(
        '.top-usp-bar__item'
      );


    if (
      !inner ||
      items.length < 2
    ) {
      return;
    }


    let currentIndex = 0;

    let timer = null;


    function isMobile() {

      return window.innerWidth <= 749;

    }


    function goToSlide(index) {

      if (!isMobile()) {

        inner.style.transform =
          'translate3d(0, 0, 0)';

        return;

      }


      currentIndex = index;


      inner.style.transform =
        'translate3d(-' +
        (currentIndex * 100) +
        '%, 0, 0)';

    }


    function nextSlide() {

      if (!isMobile()) {
        return;
      }


      currentIndex =
        (currentIndex + 1) %
        items.length;


      goToSlide(currentIndex);

    }


    function startTimer() {

      if (timer) {

        clearInterval(timer);

      }


      if (!isMobile()) {
        return;
      }


      timer =
        setInterval(
          nextSlide,
          2000
        );

    }


    function reset() {

      currentIndex = 0;

      inner.style.transform =
        'translate3d(0, 0, 0)';

      startTimer();

    }


    /*
    ==========================================
    INITIALIZE
    ==========================================
    */

    reset();


    /*
    ==========================================
    RESIZE
    ==========================================
    */

    let resizeTimer = null;


    window.addEventListener(
      'resize',
      function () {

        clearTimeout(resizeTimer);


        resizeTimer =
          setTimeout(
            function () {

              if (!isMobile()) {

                currentIndex = 0;

                inner.style.transform =
                  'translate3d(0, 0, 0)';

                if (timer) {

                  clearInterval(timer);

                  timer = null;

                }

              } else {

                startTimer();

              }

            },
            150
          );

      }
    );


    /*
    ==========================================
    PAUSE WHILE TOUCHING
    ==========================================
    */

    inner.addEventListener(
      'touchstart',
      function () {

        if (timer) {

          clearInterval(timer);

          timer = null;

        }

      },
      {
        passive: true
      }
    );


    inner.addEventListener(
      'touchend',
      function () {

        startTimer();

      },
      {
        passive: true
      }
    );

  }


  /*
  ==========================================
  INITIALIZE ALL BARS
  ==========================================
  */

  function initialize() {

    document
      .querySelectorAll(
        '.top-usp-bar'
      )
      .forEach(
        function (bar) {

          initTopUSPBar(bar);

        }
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }


  /*
  ==========================================
  SHOPIFY THEME EDITOR
  ==========================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const bar =
        event.target.querySelector(
          '.top-usp-bar'
        );


      if (bar) {

        initTopUSPBar(bar);

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initStatsCounter(section) {

    if (!section) return;

    if (section.dataset.statsInitialized === 'true') {
      return;
    }

    section.dataset.statsInitialized = 'true';


    const numbers = section.querySelectorAll(
      '.stats-counter__number'
    );


    if (!numbers.length) return;


    let hasAnimated = false;


    /*
    ==========================================
    ANIMATE NUMBER
    ==========================================
    */

    function animateNumber(numberElement) {

      const valueElement =
        numberElement.querySelector(
          '.stats-counter__number-value'
        );


      if (!valueElement) return;


      const targetText =
        numberElement.dataset.target || '0';


      /*
        Examples:

        192K+ → 192
        170K+ → 170
        90K+  → 90
        27    → 27
        100%  → 100
      */

      const match =
        targetText.match(/[\d,.]+/);


      if (!match) {

        valueElement.textContent =
          targetText;

        return;

      }


      const target =
        parseFloat(
          match[0].replace(/,/g, '')
        );


      if (isNaN(target)) {

        valueElement.textContent =
          targetText;

        return;

      }


      const numberStart =
        match.index || 0;


      const prefix =
        targetText.substring(
          0,
          numberStart
        );


      const suffix =
        targetText.substring(
          numberStart +
          match[0].length
        );


      /*
      ------------------------------------------
      START FROM ZERO
      ------------------------------------------
      */

      valueElement.textContent =
        prefix + '0' + suffix;


      /*
      ------------------------------------------
      3D START POSITION
      ------------------------------------------
      */

      numberElement.classList.add(
        'stats-counter__number--animating'
      );


      const duration = 850;

      const startTime =
        performance.now();


      function frame(currentTime) {

        const elapsed =
          currentTime -
          startTime;


        const progress =
          Math.min(
            elapsed / duration,
            1
          );


        /*
        Smooth ease-out
        */

        const eased =
          1 -
          Math.pow(
            1 - progress,
            3
          );


        const current =
          target * eased;


        let displayNumber;


        if (target % 1 !== 0) {

          displayNumber =
            current.toFixed(1);

        } else {

          displayNumber =
            Math.floor(current);

        }


        valueElement.textContent =
          prefix +
          displayNumber +
          suffix;


        if (progress < 1) {

          requestAnimationFrame(frame);

        } else {

          /*
          Always finish with the
          exact original value.
          */

          valueElement.textContent =
            targetText;


          numberElement.classList.remove(
            'stats-counter__number--animating'
          );


          numberElement.classList.add(
            'stats-counter__number--finished'
          );

        }

      }


      requestAnimationFrame(frame);

    }


    /*
    ==========================================
    START WHEN USER SCROLLS TO SECTION
    ==========================================
    */

    function startAnimation() {

      if (hasAnimated) return;

      hasAnimated = true;


      /*
        Small stagger gives the numbers
        a more premium 3D appearance.
      */

      numbers.forEach(
        function (number, index) {

          setTimeout(
            function () {

              animateNumber(number);

            },
            index * 70
          );

        }
      );

    }


    /*
    ==========================================
    INTERSECTION OBSERVER
    ==========================================
    */

    if ('IntersectionObserver' in window) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  entry.isIntersecting
                ) {

                  startAnimation();

                  observer.disconnect();

                }

              }
            );

          },
          {
            threshold: 0.2
          }
        );


      observer.observe(section);

    } else {

      /*
        Fallback for older browsers.
      */

      startAnimation();

    }

  }


  /*
  ==========================================
  INITIAL LOAD
  ==========================================
  */

  function initialize() {

    document
      .querySelectorAll(
        '[data-stats-counter]'
      )
      .forEach(
        function (section) {

          initStatsCounter(section);

        }
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }


  /*
  ==========================================
  SHOPIFY THEME EDITOR
  ==========================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '[data-stats-counter]'
        );


      if (section) {

        initStatsCounter(section);

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-benefits"] && !Shopify.designMode) return;
  try {
    

(() => {

  const section =
    document.getElementById(
      'usp-benefits-{{ section.id }}'
    );

  if (!section) return;


  const track =
    section.querySelector(
      '.usp-mobile__track'
    );

  const dots =
    section.querySelectorAll(
      '.usp-mobile__dot'
    );

  if (!track || !dots.length) return;


  dots.forEach((dot) => {

    dot.addEventListener(
      'click',
      () => {

        const index =
          Number(
            dot.dataset.slide
          );

        const width =
          section.querySelector(
            '.usp-mobile__slide'
          ).offsetWidth;

        track.scrollTo({
          left: index * width,
          behavior: 'smooth'
        });

      }
    );

  });


  track.addEventListener(
    'scroll',
    () => {

      const slide =
        section.querySelector(
          '.usp-mobile__slide'
        );

      if (!slide) return;


      const index =
        Math.round(
          track.scrollLeft /
          slide.offsetWidth
        );


      dots.forEach(
        (dot, dotIndex) => {

          dot.classList.toggle(
            'is-active',
            dotIndex === index
          );

        }
      );

    },
    {
      passive: true
    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
